import config from 'json!../../../../config/oauth.json';

let authConfig = (OAuthProvider, OAuthTokenProvider) => {
    "ngInject";

    OAuthProvider.configure(config);

    OAuthTokenProvider.configure({
        name: 'token',
        options: {
            secure: false
        }
    });

};

export default authConfig;


// WEBPACK FOOTER //
// ./client/app/common/auth/auth.config.js